<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="800" persistent>
    <v-card>
      <v-card-title class="mr-3">
        Para concluir o cancelamento, é obrigatório informar o motivo.
        Por favor, insira o motivo do cancelamento.
      </v-card-title>
      <v-card-text>
        <v-textarea
          class="mr-3"
          v-model="motivoCancelamentoLocal"
          label="Motivo do cancelamento"
          placeholder="Digite o motivo do cancelamento aqui..."
          outlined
          rows="4"
        ></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-btn color="error" @click="cancelar">Cancelar</v-btn>
        <v-btn
          color="primary"
          @click="confirmar"
          :disabled="motivoCancelamentoLocal === ''"
        >
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'ModalConfirmaCancelamentoAgendamento',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      motivoCancelamentoLocal: '',
    };
  },
  watch: {
    value(newValue: boolean) {
      if (!newValue) {
        this.motivoCancelamentoLocal = '';
      }
    },
  },
  methods: {
    confirmar() {
      if (this.motivoCancelamentoLocal.trim()) {
        this.$emit('confirm', this.motivoCancelamentoLocal);
        this.motivoCancelamentoLocal = '';
        this.$emit('input', false);
      }
    },
    cancelar() {
      this.motivoCancelamentoLocal = '';
      this.$emit('cancel');
      this.$emit('input', false);
    },
  },
});
</script>

<style>
.v-dialog.v-dialog--active.v-dialog--persistent .v-card {
  margin: auto;
}
</style>

